import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import _ from 'lodash';
import cx from 'classnames';
import { Tab } from 'react-bootstrap';

import { PaletteContext } from '.';

import styles from './palette.module.scss';
import { SECTION, SECTION_COLUMN } from 'constants/widgetTypes';
import { WidgetPaletteFolders } from './multiWidgetFolderPalette';

export const SectionPalette = ({ editorSession, defaultParent }) => {
  const paletteContext = React.useContext(PaletteContext);

  const { palettes = [] } = paletteContext;

  const paletteData = palettes.find(item => item.type === 'SECTIONS');
  const defaultId = _.get(paletteData, 'defaultId', null);
  const brandkitId = _.get(paletteData, 'brandkitId', null);

  const workspace = useSelector((state) => _.get(state, "workspaces.workspace.item"));
  const brandkitEnabled = _.get(workspace, 'brandkitEnabled', false);
  const showDefault = _.get(paletteData, 'showDefault', false) || !brandkitEnabled;

  return (
    <Tab.Pane eventKey="SECTIONS" className={cx(styles.tabPane, styles.commonPalette)}>
      <WidgetPaletteFolders
        editorSession={editorSession}
        defaultParent={defaultParent}
        paletteId={brandkitId}
        brandkitId={brandkitId}
        type={'default'}
        paletteData={paletteData}
        defaultPaletteId={defaultId}
        typeName={'SECTIONS'}
      />
    </Tab.Pane>
  );
}

const generateData = (columns) => {
  return {
    name: "Section",
    type: SECTION,
    properties: {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "50%, 0px",
            "rotate": "0deg"
          },
          "width": null,
          "height": "400px"
        },
        "stretched": true,
        "margin": 0,
        "padding": 0,
        "columnSpacing": 0,
        "background": {
          "type": "color",
          "color": {
            "type": "solid",
            "r": 242,
            "g": 242,
            "b": 242,
            "a": 1
          },
          "media": null,
          "opacity": 0,
          "scale": null,
          "position": null
        },
        "shadow": {
          "color": {
            "type": "solid",
            "r": 255,
            "g": 255,
            "b": 255,
            "a": 1
          },
          "axes": {
            "x": "0",
            "y": "0",
            "b": "0"
          },
          "show": false
        }
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0px, 0px",
            "rotate": "0deg"
          },
          "width": "100%",
          "height": "auto"
        },
        "stretched": false,
        "margin": 0,
        "padding": 0,
        "columnSpacing": 0,
        "background": null,
        "shadow": {
          "color": {
            "type": "solid",
            "r": 255,
            "g": 255,
            "b": 255,
            "a": 1
          },
          "axes": {
            "x": "0",
            "y": "0",
            "b": "0"
          },
          "show": false
        }
      }
    },
    widgets: _.times(columns).map((index) => {
      return {
        type: SECTION_COLUMN,
        name: "Column",
        properties: {
          "desktop": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px"
              },
              "width": `${100 / columns}%`,
              "height": null
            },
            "container": {
              "minWidth": 1200 / columns,
              "alignment": "center"
            },
            "alignment": "center",
            "background": null
          },
          "mobile": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px"
              },
              "width": "100%",
              "height": "200px"
            },
            "container": {
              "minWidth": 375,
              "alignment": null
            },
            "alignment": "center",
            "background": null
          }
        }
      }
    })
  };
}

export const sections = [{
  id: 'strip_widget_one',
  name: 'One Column',
  render: () => {
    return <p>One Column</p>
  },
  data: generateData(1)
},
{
  id: 'strip_widget_two',
  name: 'Two Columns',
  render: () => {
    return <p>Two Columns</p>
  },
  data: generateData(2)
},
{
  id: 'strip_widget_three',
  name: 'Three Columns',
  render: () => {
    return <p>Three Columns</p>
  },
  data: generateData(3)
}];